/*
     Title: Constant for PRODUCTION_PROCESS
     Description: Constant for PRODUCTION_PROCESS
     Author: Iqbal Hossain
     Date: 09-January-2022
     Modified: 09-January-2022
*/

export const FETCH_PRODUCTION_PROCESS = 'FETCH_PRODUCTION_PROCESS';
export const TOGGLE_PRODUCTION_PROCESS_SIDEBAR = 'TOGGLE_PRODUCTION_PROCESS_SIDEBAR';
export const TOGGLE_PRODUCTION_PROCESS_STATUS = 'TOGGLE_PRODUCTION_PROCESS_STATUS';
export const FETCH_PRODUCTION_PROCESS_BY_QUERY = 'FETCH_PRODUCTION_PROCESS_BY_QUERY';
export const ADD_PRODUCTION_PROCESS = 'ADD_PRODUCTION_PROCESS';
export const DELETE_PRODUCTION_PROCESS = 'DELETE_PRODUCTION_PROCESS';
export const FETCH_PRODUCTION_PROCESS_BY_ID = 'FETCH_PRODUCTION_PROCESS_BY_ID';
export const UPDATE_PRODUCTION_PROCESS = 'UPDATE_PRODUCTION_PROCESS';
export const DELETE_PRODUCTION_PROCESS_BY_RANGE = 'DELETE_PRODUCTION_PROCESS_BY_RANGE';
export const DROP_DOWN_PRODUCTION_PROCESS = 'DROP_DOWN_PRODUCTION_PROCESS';

/** Change Log
 * 08-Jan-2022(Iqbal): Add TOGGLE_PRODUCTION_PROCESS_SIDEBAR, FETCH_PRODUCTION_PROCESS_BY_QUERY, ADD_PRODUCTION_PROCESS, DELETE_PRODUCTION_PROCESS, FETCH_PRODUCTION_PROCESS_BY_ID, UPDATE_PRODUCTION_PROCESS, DELETE_PRODUCTION_PROCESS_BY_RANGE
 * 11-Jan-2022(Iqbal): Add DROP_DOWN_PRODUCTION_PROCESS
 */
